import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import "../assets/CSS/Dashboard.css";
import axiosInstance from "../axiosConfig";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";

function SalesFlowTally() {
  const [records, setRecords] = useState([]); // SalesFlow records
  const [filteredRecords, setFilteredRecords] = useState([]); // Filtered records
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [filters, setFilters] = useState({ searchQuery: "", fromDate: "", toDate: "" });


  

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  // ** Fetch all SalesFlow records **
  const fetchRecords = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/sales-flow");
      setRecords(response.data);
      setFilteredRecords(response.data);
    } catch (error) {
      console.error("Error fetching records:", error);
      // alert("Failed to fetch records.");
    }
  }, []);

  useEffect(() => {
    fetchRecords();
  }, [fetchRecords]);

  // ** Handle input changes for filters **
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // ** Apply filters (search & date range) **
  useEffect(() => {
    const { searchQuery } = filters;

    const filtered = records.filter((record) => {
      // const recordDate = new Date(record["RECEIVED TIME"]);

      const matchesSearch =
        searchQuery === "" ||
        [record["LOT ID"], record["SRP NO"], record.QUANTITY, record["RECEIVED TIME"] ,record.Invoice_Number]
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase());

      // const matchesDate =
      //   (fromDate === "" || recordDate >= new Date(fromDate)) &&
      //   (toDate === "" || recordDate <= new Date(toDate));

      return matchesSearch ;
    });

    setFilteredRecords(filtered);
  }, [filters, records]);


  const updateEntryStatus = async (id, status) => {
  try {
    const res = await axiosInstance.patch("/api/sales-flow/update-entry-status", {
      id,
      Entry_DoneOrNot: status,
    });

    showAlert(res.data.message, "success");
    // console.log(res.data.message);
    fetchRecords(); // Refresh table after update
  } catch (error) {
    console.error("Error updating entry status:", error);
  }
};


  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${type === "success" ? "Success!" : "Error!"}</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => (alertPlaceholder.innerHTML = ""), 2000);
  };



  // const exportRowToExcel = async (row) => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("SalesFlow");

  //   worksheet.columns = [
  //     { header: "LOT ID", key: "lot_id", width: 20 },
  //     { header: "SRP NO", key: "srp_no", width: 20 },
  //     { header: "RECEIVED TIME", key: "received_time", width: 25 },
  //     { header: "QUANTITY", key: "quantity", width: 15 },
  //     { header: "Invoice Number", key: "invoice_number", width: 25 },
  //     { header: "Confirm Time", key: "confirm_time", width: 20 },
  //     { header: "Remarks", key: "remarks", width: 30 },
  //     { header: "SO_Status", key: "so_status", width: 20 },
  //     { header: "Entry_DoneOrNot", key: "entry_status", width: 20 },
  //   ];

  //   worksheet.addRow({
  //     lot_id: row["LOT ID"],
  //     srp_no: row["SRP NO"],
  //     received_time: row["RECEIVED TIME"],
  //     quantity: row["QUANTITY"],
  //     invoice_number: row["Invoice_Number"],
  //     confirm_time: row["Confirm Time"] || "N/A",
  //     remarks: row["Remarks"] || "N/A",
  //     so_status: row["SO_Status"] || "N/A",
  //     entry_status: row["Entry_DoneOrNot"] || "N/A",
  //   });

  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   const filename = `SalesFlow_${row["LOT ID"]}_${row["SRP NO"]}.xlsx`;
  //   saveAs(blob, filename);
  // };
   


  // ** DataTable Columns **
  const columns = [
    { name: "LOT ID",width:"185px", selector: (row) => (
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row["LOT ID"]}
      >
      {row["LOT ID"]}
      </span>
    ), sortable: true },
    { name: "SRP NO", selector: (row) => row["SRP NO"], sortable: true },
    { name: "Issued Time", width:"170px", selector: (row) =>(
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row["RECEIVED TIME"]}
      >
        {row["RECEIVED TIME"]}
      </span>
    ) , sortable: true },
    { name: "Quantity", selector: (row) => row["QUANTITY"], sortable: true },
    { name: "Invoice Number", selector: (row) => row["Invoice_Number"] || "N/A", sortable: true },
    { name: "Confirmed", selector: (row) => (row["Confirm Time"] ? "Yes" : "No"), sortable: true },
    { name: "Remarks",width:"180px", selector: (row) =>(
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row["Remarks"]}
      >
      {row["Remarks"] || "N/A"}
      </span>
    ), sortable: true },
    { name: "Status",width:"150px", selector: (row) =>(
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row["SO_Status"]}
      >
      { row["SO_Status"] || "N/A"}
      </span>

    ), sortable: true },
    {
      name: "Entry Done?",
      selector: (row) => row.Entry_DoneOrNot || "N/A",
      sortable: true,
    },
    {
      name: "Entry Status", width:"180px",
      cell: (row) => (
        <div className="d-flex gap-2">
          <button
            className="btn btn-success btn-sm"
            onClick={() => updateEntryStatus(row.ID, "Done")}
          >
            Done
          </button>
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => updateEntryStatus(row.ID, "Not Done")}
          >
            Not Done
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    // {
    //   name: "Export Data", 
    //   cell: (row) => (
    //     <div className="d-flex gap-2">
    //         <button
    //             className="btn btn-primary btn-sm"
    //             onClick={() => exportRowToExcel(row)}
    //           >
    //             Export
    //           </button>
    //     </div>
    //   ),
    //   ignoreRowClick: true,
    //   allowOverflow: true,
    //   button: true,
    // },

  ];

  

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{ height: "fit-content" }}>
          <div id="alertPlaceholder"></div>
          <div className="">
          <div className="d-flex justify-content-between align-items-center"> 
            <h3 className="mb-5">Sales Flow</h3>
            <div className="d-flex gap-2">
          

           
                </div>
                </div>


            {/* Filter Section */}
            <input
                  type="text"
                  name="searchQuery"
                  value={filters.searchQuery}
                  onChange={handleFilterChange}
                  className="form-control me-2 mb-3"
                  style={{ width: "auto" }}
                  placeholder="Search..."
                />

            <DataTable
              columns={columns}
              data={filteredRecords}
              pagination
              highlightOnHover
            />
          </div>
        </main>
      </div>


  
    </div>
  );
}

export default SalesFlowTally;
